import { HttpClient, HttpParams } from '@angular/common/http'
import { ChangeDetectorRef, Injectable } from '@angular/core'
import { AbstractControl, FormGroup } from '@angular/forms'
import { EnderecoModel, MunicipioModel, UFDomainModel } from '@shared/models/backend'
import { SelectFieldProvider } from '@widgets/select-field/select-field-provider'
import { take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class EnderecoService {
  constructor(private http: HttpClient) {}

  getMunicipios(ufId?: string, query?: string) {
    let params = new HttpParams()
    if (query) {
      params = params.append('query', query)
    }
    if (ufId) {
      params = params.append('coUF', ufId)
    }
    return this.http
      .get<MunicipioModel[]>('/api/public/municipio', { params })
      .pipe(take(1))
  }

  handleUFChanged(form: FormGroup, municipioProvider: SelectFieldProvider<MunicipioModel>, ufSelected: UFDomainModel) {
    const municipio: AbstractControl = form.controls.municipio
    ufSelected ? municipio.enable() : municipio.disable()
    if (ufSelected?.id !== municipio?.value?.ufId) {
      municipio.reset()
    }
    this.getMunicipios(ufSelected?.id).subscribe((data) => {
      municipioProvider.options = data
    })
  }

  handleMunicipioChanged(
    uf: AbstractControl,
    ref: ChangeDetectorRef,
    municipioProvider: SelectFieldProvider<MunicipioModel>,
    search: string
  ) {
    this.getMunicipios(uf?.value?.id, search).subscribe((data) => {
      municipioProvider.options = data
      ref.markForCheck()
    })
  }

  handleSemCEPChanged(form: FormGroup, semCEP: boolean): void {
    const cep = form.controls.cep
    cep.enable()
    if (semCEP) {
      cep.disable()
      cep.reset()
    }
  }

  handleSemNumeroChanged(form: FormGroup, semNumero: boolean): void {
    const numero = form.controls.numero
    numero.enable()
    if (semNumero) {
      numero.disable()
      numero.reset()
    }
  }

  handleCepSearch(form: FormGroup, cep: string): void {
    this.http
      .get<EnderecoModel>('/api/public/cep/' + cep)
      .pipe(take(1))
      .subscribe((data) => {
        data?.bairro ? form.controls.bairro.setValue(data.bairro) : form.controls.bairro.reset()
        data?.logradouro ? form.controls.logradouro.setValue(data.logradouro) : form.controls.logradouro.reset()
        data?.uf ? form.controls.uf.setValue(data.uf) : form.controls.uf.reset()
        data?.municipio ? form.controls.municipio.setValue(data.municipio) : form.controls.municipio.reset()
        form.controls.numero.reset()
        form.controls.complemento.reset()
        form.controls.semNumero.reset()
      })
  }

  handleCepReset(form: FormGroup): void {
    form.controls.logradouro.reset()
    form.controls.uf.reset()
    form.controls.municipio.reset()
    form.controls.bairro.reset()
    form.controls.numero.reset()
    form.controls.complemento.reset()
    form.controls.semNumero.reset()
  }
}
